export const CHART_NAME_OPTIONS = [
  'Comprehensive Oral Exam (COE)',
  'Periodic Oral Exam (POE)',
  'Limited Exam',
  'Consultation',
] as const

export type ChartNamePreset = (typeof CHART_NAME_OPTIONS)[number]
